<div class="twofa-card">
  <div class="twofa-header">
    <button
      class="twofa-back"
      *ngIf="showAlternateMethods()"
      type="button"
      (click)="backToCodeEntry()"
      [disabled]="loading()"
      aria-label="Volver"
    >
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="twofa-icon" [class.is-methods]="showAlternateMethods()">
      <mat-icon>{{ showAlternateMethods() ? 'swap_horiz' : 'verified_user' }}</mat-icon>
    </div>

    <div class="twofa-title">
      <h3>{{ dialogTitle() }}</h3>
      <p>{{ dialogDescription() }}</p>
    </div>
  </div>

  <div class="otp-wrap" *ngIf="!showAlternateMethods()" [class.is-disabled]="loading()">
    <input
      class="otp-input"
      [disabled]="loading()"
      [formControl]="code"
      maxlength="6"
      inputmode="numeric"
      autocomplete="one-time-code"
      placeholder="- - - - - -"
      (input)="onOtpInput($event)"
    />

    <div class="otp-boxes" aria-hidden="true">
      <div class="otp-box" [class.filled]="otpChar(0)">
        {{ otpChar(0) || '-' }}
      </div>
      <div class="otp-box" [class.filled]="otpChar(1)">
        {{ otpChar(1) || '-' }}
      </div>
      <div class="otp-box" [class.filled]="otpChar(2)">
        {{ otpChar(2) || '-' }}
      </div>
      <div class="otp-box" [class.filled]="otpChar(3)">
        {{ otpChar(3) || '-' }}
      </div>
      <div class="otp-box" [class.filled]="otpChar(4)">
        {{ otpChar(4) || '-' }}
      </div>
      <div class="otp-box" [class.filled]="otpChar(5)">
        {{ otpChar(5) || '-' }}
      </div>
    </div>

    <div class="twofa-hint" *ngIf="code.invalid && code.touched">
      CODIGO INVALIDO. VERIFICA LOS 6 DIGITOS.
    </div>
  </div>

  <button
    class="twofa-switch"
    *ngIf="!showAlternateMethods()"
    type="button"
    (mousedown)="onOpenAlternateMethodsMouseDown($event)"
    (click)="openAlternateMethods()"
    [disabled]="loading()"
  >
    Probar otro metodo
  </button>

  <div class="twofa-mediums" *ngIf="showAlternateMethods()">
    <div class="twofa-mediums__loading" *ngIf="loadingMediums()">
      Cargando medios disponibles...
    </div>

    <div class="twofa-mediums__list" *ngIf="!loadingMediums() && mediums().length">
      <label
        class="medium-option"
        *ngFor="let medium of mediums(); trackBy: trackByMediumId"
        [class.is-disabled]="!medium.activo"
      >
        <input
          type="radio"
          name="twoFactorMedium"
          [formControl]="selectedMediumId"
          [value]="medium.idMedioAutenticacion"
          [disabled]="loading() || !medium.activo"
        />

        <div class="medium-option__content">
          <span
            class="medium-option__badge"
            [class.is-whatsapp]="mediumKind(medium) === 'whatsapp'"
            [class.is-mail]="mediumKind(medium) === 'mail'"
          >
            <mat-icon class="medium-option__icon" *ngIf="mediumKind(medium) === 'whatsapp'">forum</mat-icon>
            <mat-icon class="medium-option__icon" *ngIf="mediumKind(medium) === 'mail'">mail</mat-icon>
            <mat-icon class="medium-option__icon" *ngIf="mediumKind(medium) === 'generic'">alternate_email</mat-icon>
          </span>
          <span class="medium-option__title">{{ medium.descripcion }}</span>
        </div>
      </label>
    </div>

    <div class="twofa-mediums__empty" *ngIf="!loadingMediums() && !mediums().length">
      No se encontraron medios alternos disponibles.
    </div>

    <label class="remember-option" *ngIf="hasActiveMediums()">
      <input
        type="checkbox"
        [formControl]="rememberMedium"
        [disabled]="loading()"
      />
      <span>Guardar este medio como preferido para futuros codigos</span>
    </label>

    <button
      class="btn secondary"
      type="button"
      (click)="onSendSelectedMedium()"
      [disabled]="loading() || loadingMediums() || !canSendSelectedMedium()"
    >
      Enviar por este medio
    </button>
  </div>

  <div class="twofa-actions">
    <button
      class="btn link"
      *ngIf="!showAlternateMethods()"
      type="button"
      (click)="onResendDefault()"
      [disabled]="loading()"
    >
      Reenviar codigo
    </button>

    <div class="right">
      <button class="btn ghost" type="button" (click)="onCancel()" [disabled]="loading()">Cancelar</button>
      <button
        class="btn primary"
        *ngIf="!showAlternateMethods()"
        type="button"
        (click)="onConfirm()"
        [disabled]="loading() || code.invalid"
      >
        Confirmar
      </button>
    </div>
  </div>
</div>
